import React, { useState } from 'react';
import logo from '../../assets/only-fish.webp';
import './styles.css';

type TopbarProps = {
  onNavigate: (href: string) => void;
};

function Topbar({ onNavigate }: TopbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const href = event.currentTarget.getAttribute('href');
    if (!href) return;
    if (href.startsWith('http')) return;
    event.preventDefault();
    onNavigate(href);
    setMenuOpen(false);
  };

  const handleContactClick = () => {
    onNavigate('/#contact');
    setMenuOpen(false);
  };

  return (
    <header className="topbar">
      <a className="brand" href="/" onClick={handleNavClick}>
        <img
          className="brand-mark"
          src={logo}
          alt="FR Fisheries logo"
          loading="lazy"
          decoding="async"
        />
        <div>
          <div className="brand-name">FR Fisheries</div>
          <div className="brand-tag">Decades of freshness, delivered</div>
        </div>
      </a>
      <nav className="nav">
        <a href="/#supply" onClick={handleNavClick}>
          Supply
        </a>
        <a href="/catalog" onClick={handleNavClick}>
          Catalog
        </a>
        <a href="/#network" onClick={handleNavClick}>
          Network
        </a>
        <a href="/#faq" onClick={handleNavClick}>
          FAQ
        </a>
        <a href="/about" onClick={handleNavClick}>
          About
        </a>
      </nav>
      <button
        className="btn btn-ghost topbar-contact"
        type="button"
        onClick={handleContactClick}
      >
        Contact Us
      </button>
      <button
        className="topbar-menu-btn"
        type="button"
        onClick={() => setMenuOpen((o) => !o)}
        aria-expanded={menuOpen}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
      >
        <span className={`topbar-menu-line ${menuOpen ? 'open' : ''}`} />
        <span className={`topbar-menu-line ${menuOpen ? 'open' : ''}`} />
        <span className={`topbar-menu-line ${menuOpen ? 'open' : ''}`} />
      </button>
      <div className={`topbar-mobile-menu ${menuOpen ? 'open' : ''}`} aria-hidden={!menuOpen}>
        <a href="/#supply" onClick={handleNavClick}>
          Supply
        </a>
        <a href="/catalog" onClick={handleNavClick}>
          Catalog
        </a>
        <a href="/#network" onClick={handleNavClick}>
          Network
        </a>
        <a href="/#faq" onClick={handleNavClick}>
          FAQ
        </a>
        <a href="/about" onClick={handleNavClick}>
          About
        </a>
        <button type="button" onClick={handleContactClick}>
          Contact Us
        </button>
      </div>
    </header>
  );
}

export default Topbar;
